import {useSuspenseQuery} from "@apollo/client";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {CheckGlobalAlertResponse, GQL_CHECK_GLOBAL_ALERT} from "@/lib/queries/alerting.ts";
import {MonitoringServiceType} from "@/lib/types/checks.ts";

export const AlertDetailsModalButtons = ({id}: {id: number}) => {
  const {user} = useCurrentUserContext();
  const {
    data: {globalAlertState},
  } = useSuspenseQuery<CheckGlobalAlertResponse>(GQL_CHECK_GLOBAL_ALERT, {
    variables: {
      id: id,
    },
  });

  return (
    <>
      {!globalAlertState.service_is_deleted && user?.has_write_access && (
        <Button as={Link} variant={"secondary"} to={`/checks?pop=${globalAlertState.service.id}`}>
          Edit Check
        </Button>
      )}
      {!globalAlertState.service_is_deleted &&
        globalAlertState.alert &&
        globalAlertState.service_monitoring_type !== MonitoringServiceType.NETWORK && (
          <Button as={Link} variant={"secondary"} to={`/checks/${globalAlertState.service.id}/analysis`}>
            Real-Time Analysis
          </Button>
        )}
    </>
  );
};
